import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { TAXONOMY_SERVICE } from "../config/index.ts";
import { Taxonomy } from "../models/index.ts";

export const taxonomyInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${TAXONOMY_SERVICE.LABEL}/int` },
  {
    createTaxonomy: apiEndpoint({
      body: Taxonomy.createSchema.omit({ controllerPrincipalId: true }),
      response: z.object(
        { taxonomy: Taxonomy.schema },
        { taxonomy: "The taxonomy created, recorded as the calling service's" },
      ),
    }),
    getTaxonomies: apiEndpoint({
      body: z.object(
        { principalId: Taxonomy.shape.principalId },
        { principalId: Taxonomy.descriptions.principalId },
      ),
      response: z.object(
        { items: z.array(Taxonomy.schema) },
        { items: "The user's taxonomies the calling service created" },
      ),
    }),
  },
);
